import { useEffect } from 'react';
export function track(eventName, properties) {
  return new Promise(function (resolve, reject) {
    window.analytics.track("developer-".concat(eventName), properties, function (err) {
      if (err) {
        return reject(err);
      }

      return resolve();
    });
  });
}
export function loadSegment(segmentId) {
  var integrations = {
    All: false,
    Intercom: true,
    'Google Analytics': true
  };
  /* eslint-disable */

  /* prettier-ignore */

  !function () {
    var analytics = window.analytics = window.analytics || [];
    if (!analytics.initialize) if (analytics.invoked) window.console && console.error && console.error("Segment snippet included twice.");else {
      analytics.invoked = !0;
      analytics.methods = ["trackSubmit", "trackClick", "trackLink", "trackForm", "pageview", "identify", "reset", "group", "track", "ready", "alias", "debug", "page", "once", "off", "on"];

      analytics.factory = function (t) {
        return function () {
          var e = Array.prototype.slice.call(arguments);
          e.unshift(t);
          analytics.push(e);
          return analytics;
        };
      };

      for (var t = 0; t < analytics.methods.length; t++) {
        var e = analytics.methods[t];
        analytics[e] = analytics.factory(e);
      }

      analytics.load = function (t, e) {
        var n = document.createElement("script");
        n.type = "text/javascript";
        n.async = !0;
        n.src = "https://cdn.segment.com/analytics.js/v1/" + t + "/analytics.min.js";
        var a = document.getElementsByTagName("script")[0];
        a.parentNode.insertBefore(n, a);
        analytics._loadOptions = e;
      };

      analytics.SNIPPET_VERSION = "4.1.0";
      analytics.load(segmentId, {
        integrations: integrations
      });
      analytics.page();
    }
  }();
  /* prettier-ignore */

  /* eslint-enable */
}
export var identify = function identify(id, payload) {
  return window.analytics.identify(id, payload);
};
export var SegmentProvider = function SegmentProvider(_ref) {
  var children = _ref.children,
      segmentId = _ref.segmentId;
  useEffect(function () {
    loadSegment(segmentId || 'iuwUzRjCbX2iKgf5qvHhM4FfMJOZN4tQ');
  }, [segmentId]);
  return children;
};